import React from 'react';
import {
  CheckCircle,
  PlusCircle,
  ArrowCircleRight,
  UsersThree,
  Slideshow,
  CardsThree,
  ListMagnifyingGlass,
  ShareNetwork,
  Icon,
} from '@phosphor-icons/react';
import classNames from 'classnames';
import parse from 'html-react-parser';

import { ButtonLink } from '../../../../components/general';

interface Props {
  type: string;
  heading: string;
  subheading: string;
  isComplete?: boolean;
  link: string | null;
}

const VBBtn: React.FC<Props> = (props) => {
  const { type, heading, subheading, isComplete, link } = props;

  const isUploadBtn = ['people', 'hl-reel', 'clips'].includes(type);

  const getMainIcon = (): Icon | null => {
    switch (type) {
      case 'people':
        return UsersThree;
      case 'hl-reel':
        return Slideshow;
      case 'clips':
        return CardsThree;
      case 'review':
        return ListMagnifyingGlass;
      case 'share':
        return ShareNetwork;
      default:
        return null;
    }
  };

  const getSideIcon = (): Icon => {
    if (isComplete) return CheckCircle;
    if (isUploadBtn) return PlusCircle;
    return ArrowCircleRight;
  };

  const MainIcon = getMainIcon();
  const SideIcon = getSideIcon();

  const btnClass = classNames(
    'w-full flex items-center p-3 gap-3 text-left no-underline rounded-md border transition-all hover:text-white',
    isComplete
      ? 'border-success-900 text-success-900 hover:bg-success-900'
      : isUploadBtn
        ? 'border-grey-900 text-gray-500 hover:bg-grey-900'
        : 'border-purple-700 text-purple-700 hover:bg-gradient-purple-light',
  );

  const iconClass = 'w-8 h-8 sm:w-10 sm:h-10';

  return (
    <ButtonLink
      id={`vb-btn-${type}`}
      to={link ?? '#'}
      variant="custom"
      colour="custom"
      className={btnClass}
      disabled={!link}
    >
      {MainIcon && <MainIcon className={iconClass} />}

      <div className="w-[calc(100%_-_1.5rem_-_4rem)] sm:w-[calc(100%_-_1.5rem_-_5rem)]">
        <div className="text-lg font-bold uppercase">{heading}</div>

        <div className="text-sm">{parse(subheading)}</div>
      </div>

      <div className="ml-auto rounded-full bg-white">
        <SideIcon
          className={classNames(
            iconClass,
            isComplete
              ? 'text-success-900'
              : isUploadBtn
                ? 'text-grey-900'
                : 'text-purple-700',
          )}
        />
      </div>
    </ButtonLink>
  );
};

export default VBBtn;
